import { render } from "./BigKPISection.vue?vue&type=template&id=239e875e"
import script from "./BigKPISection.vue?vue&type=script&lang=js"
export * from "./BigKPISection.vue?vue&type=script&lang=js"

import "./BigKPISection.vue?vue&type=style&index=0&id=239e875e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__